import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { DebtCollection } from '../../model/debt-collection';
import { DebtCollectionCommandHandlerResolver } from '../../service/command/debt-collection-command-handler-resolver.service';
import { DebtCollectionService } from '../../service/data/debt-collection.service';

@Component({
    selector: 'app-debt-collection-form',
    templateUrl: './debt-collection-form.component.html',
    styleUrls: ['./debt-collection-form.component.scss'],
    providers: [DebtCollectionCommandHandlerResolver, { provide: DataService, useExisting: DebtCollectionService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DebtCollectionFormComponent extends FormComponentBase<DebtCollection> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    factory: ColumnDefinitionFactory,
    handlerResolver: DebtCollectionCommandHandlerResolver,
    service: DebtCollectionService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, commandDispatcher, handlerResolver);

    this.addDeleteMenu = false;

    this.columnTransactionsDefinition = [
      factory.createDate('DEBT_COLLECTION.PAYMENT_DATE', 'paymentDate'),
      factory.create('PAYMENT.PAYER_NAME', 'payerNameAndAddress'),
      factory.createMoney('COMMON.AMOUNT', 'amount'),
    ];

    this.columnDebtCollectionLogDefinition = [
      factory.createDateTime('DIRECT_DEBIT.CREATED_DATE', 'createdAt'),
      factory.create('COMMON.DESCRIPTION', 'description'),
    ];
  }

  columnTransactionsDefinition: ColumnDefinition[];
  columnDebtCollectionLogDefinition: ColumnDefinition[];
  showDebtCollectionLog: boolean;

  protected createModel(): DebtCollection {
    return new DebtCollection();
  }

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      agencyErrandId: this._fc.createReadonly('DEBT_COLLECTION.AGENCY_ERRAND_ID', this.dataContext.agencyErrandId),
      amount: this._fc.createReadonly('COMMON.AMOUNT', this.dataContext.amount),
      company: this._fc.createReadonly('COMMON.COMPANY', this.dataContext.company),
      invoiceAmount: this._fc.createReadonly('INVOICE.INVOICEAMOUNT', this.dataContext.invoiceAmount),
      invoiceNumber: this._fc.createReadonly('INVOICE.INVOICE_NUMBER', this.dataContext.invoiceNumber),
      invoiceRecipient: this._fc.createReadonly('INVOICE.RECIPIENT_NAME', this.dataContext.invoiceRecipient),
      unpaidInvoiceAmount: this._fc.createReadonly('INVOICE.REMAINING_AMOUNT', this.dataContext.unpaidInvoiceAmount),
      externalSystemName: this._fc.createReadonly('COMPANY.DEBT_COLLECTION.DEBT_COLLECTION_COMPANY', this.dataContext.externalSystemName),
      createdAt: this._fb.group({}),
    });
  }

  showTransactions: boolean;

  protected init(data: DebtCollection) {
    super.init(data);
    this.showTransactions = data.paymentUpdates.length > 0;
    this.showDebtCollectionLog = data.debtCollectionLogs && data.debtCollectionLogs.length > 0;
  }
}
